import _each from 'lodash/each';
import _extend from 'lodash/extend';
import tokenizeChinese from './tokenizers/chinese';
import tokenizeJapanese from './tokenizers/japanese';
export const CJKTokenizer = {
    tokenizeChinese,
    tokenizeJapanese,
    tokenize(text, options = {}) {
        const languages = options.languages || [
            'chinese',
            'japanese',
        ];
        const languageSpecified = {};
        _each(languages, (language) => {
            languageSpecified[language] = true;
        });
        return _extend(languageSpecified.japanese ? tokenizeJapanese(text, options) : {}, languageSpecified.chinese ? tokenizeChinese(text, options) : {});
    }
};
//# sourceMappingURL=index.js.map